import React from "react";
import { Alert, AlertTitle } from "@material-ui/lab";
import { Grid } from "@material-ui/core";

const WarningBox = (props) => {
  if (props.ShowError) {
    return (
      <Alert
        severity="success"
        style={{
          position: "fixed",
          bottom: 0,
          zIndex: 10,
          width: "33%",
          height: 80,
        }}
      >
        <Grid container justify="center" alignItems="center">
          <Grid item>
            <AlertTitle>Success</AlertTitle>
            <strong>Alle gegevens zijn opsgeslagen</strong>
          </Grid>
        </Grid>
      </Alert>
    );
  } else {
    return (
      <React.Fragment>
        <Alert
          severity="warning"
          style={{
            position: "fixed",
            bottom: 0,
            zIndex: 10,
            width: "33%",
            height: 80,
          }}
        >
          <Grid container justify="center" alignItems="center">
            <Grid item>
              <AlertTitle>Pas op</AlertTitle>
              <strong>Nog niet alle gegevens zijn opgeslagen!</strong>
            </Grid>
          </Grid>
        </Alert>
        {/* <Prompt
          when={this.shouldBlockNavigation}
          message="Niet alles is op geslagen, weet je zeker dat je de pagina wilt verlaten?"
          message={(location, action) => {
            if (action === "POP") {
              alert("Backing up...");
            }
  
            return location.pathname.startsWith("/app")
              ? true
              : `Are you sure you want to go to ${location.pathname}?`;
          }}
        /> */}
      </React.Fragment>
    );
  }
};

export default WarningBox;
